<script src="../classes/playlistmanager.js"></script>
<template>
    <li class="menu-item" @mouseover="hover(true)" @mouseleave="hover(false)" :class="{'active': $menuItemActive}">
        <router-link :to="{name: item.id, path: item.link}" :style="$menuItemTextStyle">
            <span class="menu-item-icon nav-icon" :style="$menuItemIconStyle">
                <font-awesome-icon :icon="[item.icon.prefix, item.icon.name]"></font-awesome-icon>
            </span>
            <span class="nav-text">{{item.name}}</span>
        </router-link>
    </li>
</template>

<script>
    import Configure from './../mixins/configure'

    export default {
        props: ['item'],
        mixins: [Configure],
        methods: {
            hover(isHovering) {
                this.$data.$hover.menuItem = isHovering
            },
        }
    }
</script>

<style lang="scss" scoped>
    .menu-item > a {
        &, &:hover, &:active, &:focus {
            background: transparent;
        }
    }
</style>